export const environment = {
  production: true,

  API_URL: 'https://portal-api-qa.golmn.com/v1/',
  API_TOKEN_URL: 'https://portal-api-qa.golmn.com/token',
  AZURE_API_URL: 'https://app-lmn-internal-qa-internal.golmn.com/api/v1',
  PAYMENTS_FUNCTION_API_URL: 'https://func-lmn-payments-qa.azurewebsites.net/api/',
  GOOGLE_API_KEY: 'AIzaSyAHxIqABLc5b5q_FI4Fpa6ogQZRuRhmpJY',
  CARD_CONNECT_URL: 'https://fts-uat.cardconnect.com/',
  SEJDA_PUBLISHABLE_KEY: 'api_public_fac4b4c1e04a4b7b9c8ff8f1fd8fd77d',
  GA_MEASUREMENT_ID: 'dev',

  PAYRIX_API_KEY: '06b1ee6ed11c4cb6c6f01c9074be51db',
  PAYRIX_PAYFRAME: 'https://test-api.payrix.com/payFrameScript',
  PAYRIX_PAYFIELDS: 'https://test-api.payrix.com/payFieldsScript',
  PAYRIX_URL: 'https://test-api.payrix.com/',
  LAUNCH_DARKLY_CLIENT_ID: '676195a7b6863b0974448b83',
  PENDO_KEY: 'b6aced95-30ba-4c88-609f-cdfdb28116a4',

  STRIPE_PUBLISHABLE_KEY_USD:
    'pk_test_51SO0t28i9mesbC4lSc9t7NfQZW6QhwQeWVao5EhiNnJXlusxXcJcFwjsvnVSGwdsQlYYYzY2zxvS1rEAEIHjv4qS00EsfrISY2',
  STRIPE_PUBLISHABLE_KEY_CAD:
    'pk_test_51SQVALI6XQ08NiI7Q59nyaZc1XxlW8OcXDmXzEbxNDHBMP261LQjvWSxJOo1Np3ifYT6kiV1hk59x0xQCGdywoZo00rnEfGCI3',

  DATA_DOG_ID: 'pub35eecc3995587f614d19164371d3fbea',
  DATA_DOG_ENV: 'qa',
  DATA_DOG_VERSION: '1',

  RECAPTCHA_SITE_KEY: '6Le4XwstAAAAAJCExEuVxEwGlQXR7w2b_o2c3orw',
};
